import { FlatObject } from './helpers';

// https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
export const getQueryStringParams = (qs?: string): Record<string, string> => {
  if (!qs) {
    qs = window.location.search.substring(1);
  }

  let match;
  const pl = /\+/g, // Regex for replacing addition symbol with a space
    search = /([^&=]+)=?([^&]*)/g,
    decode = (s: string) => decodeURIComponent(s.replace(pl, ' '));
  const urlParams: FlatObject = {};
  while ((match = search.exec(qs))) {
    urlParams[decode(String(match[1]))] = decode(String(match[2]));
  }

  return urlParams;
};

export const makeQueryString = (params: FlatObject): string => {
  return Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');
};

export const addUrlQueryParam = (key: string, value: string, replace = false): void => {
  const qs = getQueryStringParams();
  qs[key] = value;

  const path = window.location.href.split('?').shift();
  const url = `${path}?${makeQueryString(qs)}`;

  if (replace) {
    window.history.replaceState(null, '', url);
  } else {
    window.history.pushState(null, '', url);
  }
};

export const patchQueryParams = (updates: Record<string, string | null>, replace = false): void => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  Object.entries(updates).forEach(([key, value]) => {
    if (value === null) {
      params.delete(key);
    } else {
      params.set(key, value);
    }
  });

  url.search = params.toString();

  if (replace) {
    window.history.replaceState(null, '', url.toString());
  } else {
    window.history.pushState(null, '', url.toString());
  }
};

export const removeUrlQueryParam = (key: string) => {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  url.searchParams.delete(key);
  url.search = searchParams.toString();
  window.history.replaceState({}, document.title, url.toString());
};

export const getUrlQueryParam = (key: string): string | null => {
  const url = new URL(window.location.href);
  const val = url.searchParams.get(key);
  return val ? decodeURIComponent(val) : null;
};

// https://stackoverflow.com/questions/4907843/open-a-url-in-a-new-tab-and-not-a-new-window
export const openNewTab = (url: string, target = ''): void => {
  window.open(url, target)?.focus();
};

export const getHost = (): string => String(window.location.origin).replace(/^http(s?):\/\//, '');

export const pathIsActive = (path: string, matchPrefix?: boolean): boolean => {
  const currentPath = String(window.location.pathname);
  return currentPath === path || (!!matchPrefix && currentPath.startsWith(path));
};

export const pathIsExternal = (path: string): boolean =>
  Boolean(String(path).match(/^http(s?):\/\//));

export const withoutProto = (s: string): string => s.replace(/^http(s?):\/\//, '');

export const getDomain = (source: string): string => {
  try {
    const sourceUrl = new URL(source);
    return sourceUrl?.hostname || '';
  } catch {
    return '';
  }
};

export const addProtocol = (url: string): string => {
  if (!url || url.match(/^http(s?):\/\//)) {
    return url;
  }

  return `http://${url}`;
};
